import { Box, FormControlLabel, Typography } from "@mui/material";
import styles from "./volunteer.module.scss";
import { ChangeEvent, useState } from "react";
import { CommonButton, CustomCheckbox } from "../common/StyledComponents/StyledFields";

interface above18Props {
  callApi: () => void;
  ParticipantName: string;
  setShowRegisterForm: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAbove18: React.Dispatch<React.SetStateAction<boolean>>;
}

const Above18 = (props: above18Props) => {
  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setChecked(event.target.checked);
  };

  const handleCancel = () : void => {
    props.setShowAbove18(false);
    props.setShowRegisterForm(true);
  };

  return (
    <Box className={styles.totalConatiner}>
      <Typography className={styles.Heading}>
        UNCONDITONAL RELEASE OF LIABILITY & AGREEMENT TO INDEMNIFY
        <br />
        <Typography className={styles.Heading}>
          (the "Agreement")
        </Typography>{" "}
        <br /> ***THIS IS A LEGALLY BINDING AGREEMENT, PLEASE READ CAREFULLY***
      </Typography>
      <Typography className={styles.subHeading}>
        <strong>Participant:</strong>{" "}
        <span
          style={{ textDecoration: "underline", fontWeight: "bold" }}
        >{`${props.ParticipantName}`}</span>
      </Typography>
      <Typography className={styles.subHeading}>
        <b>Program:</b> Volunteering in Frontdesk/Kitchen/Maintenance/Temple{" "}
        <b> Location:</b> HCCC Livermore
      </Typography>
      <Box className={styles.theory}>
        <ul>
          <li>
            <Typography>
              <strong>PARTIES BOUND BY THIS AGREEMENT</strong>
            </Typography>
            <li className={styles.outerCircle}>
              <strong>HCCC:</strong> As used in this agreement, the term HCCC
              includes Hindu Community and Cultural Center, Inc and its
              Directors and Officers together with all the volunteers and
              coordinators, employees, and agents.
            </li>
          </li>
          <li>
            <Typography>
              <strong>UNCONDITIONAL RELEASE OF LIABILITY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              In consideration of my being permitted to participate in the HCCC
              program described above, I,{" "}
              <span
                style={{ textDecoration: "underline", fontWeight: "bold" }}
              >{`${props.ParticipantName}`}</span>{" "}
              , hereby release HCCC from any and all claims and liability of any
              kind that may arise as a result of my participation, including but
              not limited to claims regarding or alleging HCCC’s negligence.
              This release includes all travel to and from the program and
              activities in preparation for participation in the program
              described above. By signing this agreement, the Participant
              releases HCCC of any and all liability, waives any and all claims
              against HCCC, and agrees not to sue HCCC based on from the
              participant’s involvement in the program stated above.
            </li>
          </li>
          <li>
            <Typography>
              <strong>AGREEMENT TO INDEMNIFY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              As further consideration of my participation in the HCCC program
              described above, I agree to hold harmless and indemnify HCCC for
              any and all claims that may be brought against HCCC as a result of
              my participation in the program stated above, including all costs
              and attorney fees incurred, as well as any other expenses.
            </li>
          </li>
          <li>
            <Typography>
              <strong>SEVERABILITY</strong>
            </Typography>
            <li className={styles.outerCircle}>
              In the event that any term of this agreement is found to be
              invalid for any reason, such a finding shall not affect the
              validity of any other terms of this Agreement.
            </li>
          </li>
          <li>
            <Typography>
              <strong>PARENTS/GUARDIAN(S) CONSENT AND ACKNOWLEDGMENT</strong>
            </Typography>
            <li className={styles.outerCircle}>
              I have read and fully understand the terms of this Agreement,
              <span style={{ fontWeight: "bold" }}>
                I UNDERSTAND THAT I HAVE GIVEN UP SUBSTANTIAL RIGHT BY SIGNING
                THIS DOCUMENT.
              </span>
            </li>
          </li>
        </ul>
      </Box>
      <Box>
        <FormControlLabel
        onSubmit={props.callApi}
          control={
            <CustomCheckbox checked={checked} onChange={handleCheckboxChange} />
          }
          label="I Agree to the terms and conditions"
        />
      </Box><CommonButton
          onClick={handleCancel}
          sx={{
            marginTop: "10px",
            display: " inline-flex",
            height: "38px",
            padding: " 8px 16px",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          Cancel
        </CommonButton>
      <CommonButton
        sx={{ marginTop: "10px",marginLeft: "17.5px", }}
        onClick={props.callApi}
        disabled={!checked}
        type="submit"
      >
        Submit
      </CommonButton>
    </Box>
  );
};

export default Above18;
